// extracted by mini-css-extract-plugin
export var closeButton = "_cw-1";
export var closeX = "_cw-3";
export var container = "_cw-0";
export var image = "_cw-2";